import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class HistoricalFundsBalanceError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('HistoricalFundsBalanceError', ...args);
    }
}
export default HistoricalFundsBalanceError;
